import { CookiePurpose } from "../../Index";
import { loadDynamicScript } from "../../Util";
export class CivikukCookieControlService {
    Load(options, baseOnAcceptCallback, baseOnRevokeCallback) {
        if (typeof CookieControl !== 'object') {
            loadDynamicScript("cookieControl", "https://cc.cdn.civiccomputing.com/9/cookieControl-9.x.min.js", () => this.Load(options, baseOnAcceptCallback, baseOnRevokeCallback), "head");
            return;
        }
        const civikukOptions = options;
        civikukOptions.apiKey = options.apiKey;
        civikukOptions.product = options.product || 'PRO';
        civikukOptions.optionalCookies = options.optionalCookieList;
        if (civikukOptions.optionalCookies) {
            civikukOptions.optionalCookies.forEach((option) => {
                if (option.name != CookiePurpose.Analytics && option.name != CookiePurpose.Social && option.name != CookiePurpose.Preferences) {
                    console.log(`Optional cookie name "${option.name}" is not supported`);
                    return;
                }
                option.onAccept = () => {
                    option.onAcceptCallback();
                    baseOnAcceptCallback(option.name);
                };
                option.onRevoke = () => {
                    option.onRevokeCallback();
                    baseOnRevokeCallback(option.name);
                };
            });
        }
        CookieControl.load(options);
    }
    Open() {
        CookieControl.open();
    }
    UpdateConsent(purpose, accept) {
        const config = CookieControl.config();
        let category = -1;
        config.optionalCookieList.forEach((value, index) => {
            if (value.name === purpose) {
                category = index;
                return;
            }
        });
        if (category != -1) {
            CookieControl.changeCategory(category, accept);
        }
    }
}
//# sourceMappingURL=CivikukCookieControlService.js.map